import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FoundationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"foundation"}/>
}
